<ng-container *transloco="let t">
  <div class="empty-state">
    <div class="d-flex flex-column align-items-center justify-content-center p-3 p-md-5">
      @if (titleKey) {
        <h1 class="text-center">{{ t(titleKey ?? 'emptyState.sorry') }}</h1>
      }
      @if (contentKeys.length > 0) {
        @for (key of contentKeys; track key) {
          <p class="medium text-center">{{ t(key) }}</p>
        }
      } @else {
        <p class="medium text-center">{{ t('emptyState.not.able.to.find') }}</p>
        <p class="medium text-center">{{ t('emptyState.do.not.worry') }}</p>
        <p class="medium text-center" [innerHTML]="formattedMessage"></p>
      }
    </div>
  </div>
</ng-container>
